'use strict';
var parent = require('../../stable/object/get-own-property-descriptors');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/get-own-property-descriptors.js
// module id = 545
// module chunks = 13